<template>
  <div class="container category productcategory">
    <div style="position: fixed; left: 0; right: 0; top: 0; z-index: 1">
      <div class="pro_cate_header">
        <van-search :placeholder="default_search ? '搜索“' + default_search + '”' : ''" @click="searchClick" background="#fff" />
        <div class="kefu" @click="keFu">
          <img src="../../assets/images/service.png" />
        </div>
        <!-- <div class="cate" @click="goProCate">
          <img src="../../assets/images/categoryicon.png" />
        </div> -->
      </div>
      <div
        class="pro_cate_list"
        v-if="categoryList && categoryList.length && categoryList.length > 0"
      >
        <van-tabs
          @click="setCurrentSlide"
          v-model="activeIndex"
          line-width="0.24rem"
          :ellipsis="false"
          line-height="0.02rem"
        >
          <van-tab
            :class="{ 'swiper-slide': true }"
            v-for="(item, index) in categoryList"
            :name="item.id"
            :title="item.name"
            :key="index"
          ></van-tab>
        </van-tabs>
      </div>
    </div>
    <Scroller
      :is-refresh-data.sync="refresh"
      :is-loading-data.sync="loading"
      :is-finished-data.sync="finished"
      :no-data-text-data.sync="noDataText"
      @on-infinite="onInfinite"
      @on-refresh="onRefresh"
      ref="my_scroller"
      :style="{ 'padding-top': categoryList.length ? '0.88rem' : '0.44rem' }"
    >
      <div class="skinTest" v-if="$store.state.skinTextproductCategoryShow == 1">
        <skinTest :page="'productcategory'"></skinTest>
      </div>
      <div class="pro_list">
        <product-item
          v-for="(item, index) of productList"
          :key="index"
          :prolistItem="item"
          :skuSwitch="'1'"
          :markPointData="{
            scenepoint: 'CLASSIFY',
            scenedesc: categoryList.length ? categoryList[porintIndex].name : title
          }"
        ></product-item>
      </div>
      <div class="van-list__finished-text" v-if="finished">
        ————不知道买什么？
        <span style="color: #4787f0" @click="goCommunity">去社区逛逛>></span>
        ————
      </div>
    </Scroller>
    <div class="floatBtn_new">
      <img @click="goShopping" src="../../assets/images/shopping1.png" />
      <img
        v-if="isnewpersontask"
        @click="newpersontask"
        src="/static/images/new-person/newpersontask@2x.png"
      />
      <img src="/static/images/homebtn1.png" class="home" @click="homeClick" />
    </div>
  </div>
</template>

<script>
import { Search } from 'vant'
import skinTest from '../common/skinTest'
import productItem from '../common/productItem'
import { isWeixin, kefu, fenxiang } from '../../assets/common/js/config'
import Vue from 'vue'
import Scroller from '../common/Scroller'
import { Tab, Tabs } from 'vant'
Vue.use(Tab).use(Tabs)

export default {
  name: 'productCategory',
  components: {
    skinTest,
    productItem,
    [Search.name]: Search,
    Scroller
  },
  data() {
    return {
      activeIndex: 0,
      porintIndex: 0,
      id: 0,
      idSon: 0,
      categoryList: [],
      productList: [],
      default_search: '',
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: '',
      isnewpersontask: 0,
      newpersonjump: ''
    }
  },
  watch: {
    activeIndex() {
      let i = 0
      this.categoryList.map((item, index) => {
        if (item.id == this.activeIndex) {
          this.porintIndex = index
        } else {
          i++
        }
      })
      if (i >= this.categoryList.length) {
        this.porintIndex = 0
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.swiper1.swiper
    }
  },
  created() {
    var url_p = this.$route.fullPath
    console.log(url_p, this.$route)
    if (url_p.indexOf('listType=') < 0)
      url_p += url_p.indexOf('?') >= 0 ? '&listType=1' : '?listType=1'
    this.$router.replace(url_p)
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({ path: 'productcategory' })
    }
    var that = this
    that.categoryList = []
    that.id = that.$store.state.categoryId
    that.idSon = that.$store.state.categorySonId
    that.activeIndex = that.idSon
    if (!isWeixin()) {
      if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
        this.$store.commit('SKIN_PATH', 'productCategory')
        this.$store.commit('PATH_VALUE', {})
      }
    }
    // that.getData()
    // that.nowPage = 1
    // that.productList = []
    // if (that.idSon === '') {
    //   that.getListData(that.id)
    // } else {
    //   that.getListData(that.activeIndex)
    // }
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == '/' && from.name != 'homePage') {
      // 当前页面刷新不需要切换位置
      next((vm) => {
        vm.id = vm.$store.state.categoryId
        vm.idSon = vm.$store.state.categorySonId
        vm.activeIndex = vm.idSon
        vm.getData()
        vm.nowPage = 0
        vm.onInfinite()
      })
    } else {
      next((vm) => {
        /**
         * datatype = 'init'
         * 来源是商品详情页时，链接参数主要用于判断页面数据是否初始化
         * */
        if (
          from.path != '/productdetail' ||
          (from.path == '/productdetail' && to.query.datatype == 'init')
        ) {
          Object.assign(vm.$data, vm.$options.data())
          vm.categoryList = []
          vm.id = vm.$store.state.categoryId
          vm.idSon = vm.$store.state.categorySonId
          vm.activeIndex = vm.idSon
          vm.getData()
          vm.nowPage = 0
          vm.onInfinite()
        }
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    if (
      to.path != '/productdetail' ||
      (from.path == '/productdetail' && to.query.datatype == 'init')
    )
      this.loading = true
    next()
  },
  methods: {
    getData: function () {
      this.$nextTick(() => {
        this.$route.meta.title = decodeURIComponent(this.$route.query.title)
          ? decodeURIComponent(this.$route.query.title)
          : ''
        window.document.title = this.$route.meta.title
      })
      if (!this.id && this.$store.state.categoryNav) {
        this.categoryList = JSON.parse(this.$store.state.categoryNav)
        setTimeout(() => {
          this.categoryList.findIndex((item) => {
            if (item.id === this.idSon) {
              this.activeIndex = item.id
            }
          })
        }, 300)
        return
      }
      if (!this.id) return
      var urlNav = this.$ajax.getCategoryList_URL + '?cat_id=' + this.id
      var that = this
      that.$customRequestAjax(urlNav).then((res) => {
        if (res.data.code === 200) {
          that.categoryList = res.data.catlist
          setTimeout(function () {
            that.categoryList.findIndex((item) => {
              if (item.id === that.idSon) {
                that.activeIndex = item.id
              }
            })
          }, 300)
        }
      })
      this.$newuserFn((data) => {
        if (data.code == 200) {
          this.isnewpersontask = data.isnewpersontask
          this.newpersonjump = data.newpersonjump ? data.newpersonjump : ''
        }
      })
    },
    getListData: function () {
      var urlProduct =
        this.$ajax.getItemList_URL +
        '?cat_id=' +
        this.activeIndex +
        '&pageno=' +
        this.nowPage +
        '&pagesize=' +
        this.pagesize
      var that = this
      that.$customRequestAjax(urlProduct).then((res) => {
        if (res.data.code === 200) {
          if (that.nowPage === 1) {
            that.default_search = res.data.default_search || ''
            that.productList = res.data.itemlist
            that.refresh = false
          } else {
            that.productList = that.productList.concat(res.data.itemlist)
          }
          that.loading = false
          if (res.data.itemlist.length < that.pagesize) {
            that.finished = true
          } else {
            that.finished = false
          }
        }
      })
    },
    goCommunity: function () {
      this.$store.commit('COMMUNITY_TAB', 1)
      this.$router.push({
        path: '/community'
      })
    },
    setCurrentSlide(index) {
      this.activeIndex = index
      this.$store.commit('CATEGORY_SONID', this.activeIndex)
      this.nowPage = 1
      this.productList = []
      this.getListData()
    },
    goProCate() {
      if (!isWeixin()) {
        if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
          this.$store.commit('PATH_VALUE', JSON.stringify({ type: 'inside' }))
        }
      }
      this.$router.go(-1)
    },
    goShopping() {
      this.$router.push('/cart')
    },
    searchClick: function () {
      this.$router.push('/search')
    },
    newpersontask() {
      window.location = this.newpersonjump
    },
    // 客服
    keFu: function () {
      // 登录校验
      if (!isWeixin()) {
        if (this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
          this.$router.push({
            path: '/login',
            query: {
              routeval: ''
            }
          })
        } else {
          kefu()
        }
      } else {
        kefu()
      }
    },
    onRefresh() {
      this.refresh = true
      this.nowPage = 1
      this.productList = []
      this.getListData()
    },
    onInfinite() {
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getListData()
      // }, 400)
    },
    homeClick: function () {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  .pro_cate_header {
    width: 100%;
    background: #fff;
    height: 0.44rem;
    padding: 0 0.11rem;
    position: relative;
    display: flex;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    align-items: center;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -o-align-items: center;
    .kefu {
      width: 0.2rem;
      height: 0.2rem;
      margin-left: 0.1rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .cate {
      /*position: absolute;*/
      /*right: .11rem;*/
      /*bottom: .12rem;*/
      width: 0.2rem;
      height: 0.2rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .pro_cate_list {
    /*height: .3rem;*/
    background: #fff;
    /*line-height: .3rem;*/
    .van-hairline--top-bottom::after,
    .van-hairline-unset--top-bottom::after {
      border-width: 0;
    }
    .swiper-slide {
      font-size: 0.13rem;
      color: #4b4b4b;
      text-align: center;
      white-space: nowrap;
    }
    .swiper-slide.swiper-slide-active {
      color: #292929;
      font-weight: 600;
    }
    .swiper-slide.swiper-slide-active:after {
      content: '';
      height: 0.02rem;
      width: 50%;
      position: absolute;
      left: 25%;
      bottom: 0;
      background-color: #fc0324;
    }
  }
  .skinTest {
    background: #fff;
  }
  .pro_list {
    padding: 0.1rem 0.11rem 0;
    background: #fff;
    overflow: hidden;
    display: flex;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    flex-wrap: wrap;
    -moz-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    -o-flex-wrap: wrap;
    .pro_item:nth-child(2n) {
      padding-left: 0.035rem;
    }
    .pro_item:nth-child(2n-1) {
      padding-right: 0.035rem;
    }
  }
  .goShopping {
    position: fixed;
    right: 0.12rem;
    bottom: 0.8rem;
    img {
      width: 0.5rem;
      height: 0.5rem;
    }
  }
}
</style>
<style lang="scss">
.pro_cate_list .van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0;
}
.pro_cate_list {
  .van-tabs__line {
    border-radius: 0 !important;
    bottom: 22px;
    z-index: 100;
  }
}
.productcategory .van-icon-search {
  color: transparent;
  font-weight: 600;
  width: 0.2rem;
  font-size: 0.2rem;
  height: 0.2rem;
  background: url('../../assets/images/search.png') no-repeat center;
  background-size: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.productcategory .van-search__content {
  padding-left: 0.09rem;
  border: 0.01rem solid transparent;
}
.productcategory .van-field__body input::placeholder {
  font-size: 0.13rem;
}
.productcategory .van-icon-clear {
  right: 0.08rem;
}
.productcategory .van-search__content {
  background-color: #fff;
  border: 0.01rem solid #fc0324;
  border-radius: 0.15rem;
  /*padding-top: 0.005rem;*/
  /*padding-bottom: 0.005rem;*/
}
.productcategory .van-cell__value--alone {
  height: 0.27rem;
}
.productcategory .van-cell__value--alone .van-field__body {
  height: 0.27rem;
}
.productcategory .van-search {
  height: 0.44rem;
  flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  -moz-flex: 1;
  -o-flex: 1;
  display: flex;
  display: -webkit-flex;
  display: -ms-flex;
  display: -moz-flex;
  display: -o-flex;
  align-items: center;
  -webkit-align-items: center;
  -ms-align-items: center;
  -moz-align-items: center;
  -o-align-items: center;
  padding: 0;
}
.productcategory .van-field__left-icon {
  margin-right: 0.06rem;
  position: relative;
  width: 0.2rem;
}
.productcategory .van-search .van-cell {
  padding: 0;
  line-height: 0.25rem;
}
.productcategory .scroller {
  padding-top: 0.88rem;
  background: #fff;
}
.productcategory .pro_cate_list .van-tabs span {
  /*width: 0.54rem;*/
}
.productcategory .pro_cate_list .van-tab {
  padding-left: 0.14rem;
  padding-right: 0.14rem;
  flex-basis: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/category/productCategory.vue